var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1AlarmOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G1_Alarm_off_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.23 28.56L54 32v20H41V42h-6v10h-7.38L5 76H0l22.62-24 10.67-11.57 12.94-14L71 0h5L49.23 28.56zm17.39-3.66a18.76 18.76 0 015.51 13A18.77 18.77 0 0166.62 51l2.76 2.62A22.51 22.51 0 0075.94 38a22.53 22.53 0 00-6.56-15.68l-2.76 2.58zm-1.43 4.27l-3.3 2A13.12 13.12 0 0164 38a13.1 13.1 0 01-2.14 6.77l3.3 2A16.82 16.82 0 0067.9 38a16.87 16.87 0 00-2.71-8.83zm-27.4-8.86L22 32v14.77L43 24l-5.21-3.69zm-27 26.42l3.3-2A13.1 13.1 0 0111.92 38a13.12 13.12 0 012.14-6.77l-3.3-2A17 17 0 008 38a16.91 16.91 0 002.76 8.73h.03zM9.33 51a18.77 18.77 0 01-5.51-13 18.76 18.76 0 015.51-13l-2.76-2.73A22.53 22.53 0 000 38a22.51 22.51 0 006.57 15.63L9.33 51z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "G1_Alarm_off_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/G1_Alarm_off.84cd2400.svg";
export { SvgG1AlarmOff as ReactComponent };